import { HttpBackend, HttpClient } from '@angular/common/http';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';

/** Create a separate HttpClient for translations fetcher which bypasses interceptors */
export function translateHttpLoaderFactory(httpBackend: HttpBackend): TranslateHttpLoader {
  return new TranslateHttpLoader(new HttpClient(httpBackend), './assets/i18n/', '-3554cf04-dced-42b5-bc45-6dfea67edce5.json');
}
